// extracted by mini-css-extract-plugin
export default {"options":"AsideElementOptionsDev_options__6e1fp","checkbox":"AsideElementOptionsDev_checkbox__9-s8D","text":"AsideElementOptionsDev_text__WIDaz"};